import { render, staticRenderFns } from "./MaskeModule.vue?vue&type=template&id=a08c00a6"
import script from "./MaskeModule.vue?vue&type=script&lang=js"
export * from "./MaskeModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports